import { useQuery } from "@tanstack/react-query";
import { getMasterSearch } from "api/masterSearch";
import { MASTER_SEARCH_LIMIT, MIN_QUERY_LENGTH } from "./constants";

const MASTER_SEARCH_QUERY_KEY = "MASTER_SEARCH";

export const useMasterSearch = (query: string, enabled: boolean) =>
  useQuery({
    queryKey: [MASTER_SEARCH_QUERY_KEY, query],
    // Forward react-query's signal so superseded keystrokes stop costing the
    // backend an OpenSearch msearch plus the listing/lockbox SQL fan-out.
    queryFn: ({ signal }) =>
      getMasterSearch({ q: query, limit: MASTER_SEARCH_LIMIT }, signal),
    enabled: enabled && query.length >= MIN_QUERY_LENGTH,
    staleTime: 30_000
  });
